export class Base64Utils {
  static decode<T>(base64: string): T {
    return JSON.parse(atob(decodeURIComponent(base64))) as T;
  }
}
